import { styled } from 'naan/stitches.config';

export const MediumHeading = styled('h2', {
  textStyle: 'medium-heading',
});
